<template>
  <!-- App icons -->
  <LazyAtomIconAppCat v-if="icon === 'app-cat'" :class="classes" />
  <LazyAtomIconAppCatJumpingFar v-if="icon === 'app-cat-jumping-far'" :class="classes" />
  <LazyAtomIconAppCatJumpingHigh v-if="icon === 'app-cat-jumping-high'" :class="classes" />
  <LazyAtomIconAppCatJumpingLeft v-if="icon === 'app-cat-jumping-left'" :class="classes" />
  <LazyAtomIconAppCatParading v-if="icon === 'app-cat-parading'" :class="classes" />
  <LazyAtomIconAppCatSitting v-if="icon === 'app-cat-sitting'" :class="classes" />
  <LazyAtomIconAppCatWalking v-if="icon === 'app-cat-walking'" :class="classes" />
  <LazyAtomIconAppCatWashing v-if="icon === 'app-cat-washing'" :class="classes" />
  <LazyAtomIconAppCheckboxChecked v-if="icon === 'app-checkbox-checked'" :class="classes" />
  <LazyAtomIconAppCheckboxUnchecked v-if="icon === 'app-checkbox-unchecked'" :class="classes" />
  <LazyAtomIconAppDog v-if="icon === 'app-dog'" :class="classes" />
  <LazyAtomIconAppExclamationMark v-if="icon === 'app-exclamation-mark'" :class="classes" />
  <LazyAtomIconAppFacebook v-if="icon === 'app-facebook'" :class="classes" />
  <LazyAtomIconAppFacebookF v-if="icon === 'app-facebook-f'" :class="classes" />
  <LazyAtomIconAppFemale v-if="icon === 'app-female'" :class="classes" />
  <LazyAtomIconAppFemaleLarge v-if="icon === 'app-female-large'" :class="classes" />
  <LazyAtomIconAppFilter v-if="icon === 'app-filter'" :class="classes" />
  <LazyAtomIconAppGlobe v-if="icon === 'app-globe'" :class="classes" />
  <LazyAtomIconAppHeart v-if="icon === 'app-heart'" :class="classes" />
  <LazyAtomIconAppHeartFilled v-if="icon === 'app-heart-filled'" :class="classes" />
  <LazyAtomIconAppLinkedIn v-if="icon === 'app-linked-in'" :class="classes" />
  <LazyAtomIconAppLoader v-if="icon === 'app-loader'" :class="classes" />
  <LazyAtomIconAppLocate v-if="icon === 'app-locate'" :class="classes" />
  <LazyAtomIconAppLocationPin v-if="icon === 'app-location-pin'" :class="classes" />
  <LazyAtomIconAppLogOut v-if="icon === 'app-log-out'" :class="classes" />
  <LazyAtomIconAppMale v-if="icon === 'app-male'" :class="classes" />
  <LazyAtomIconAppMaleLarge v-if="icon === 'app-male-large'" :class="classes" />
  <LazyAtomIconAppUnknownGender v-if="icon === 'app-unknown-gender'" :class="classes" />
  <LazyAtomIconAppParrot v-if="icon === 'app-parrot'" :class="classes" />
  <LazyAtomIconAppPencil v-if="icon === 'app-pencil'" :class="classes" />
  <LazyAtomIconAppPig v-if="icon === 'app-pig'" :class="classes" />
  <LazyAtomIconAppRabbit v-if="icon === 'app-rabbit'" :class="classes" />
  <LazyAtomIconAppRat v-if="icon === 'app-rat'" :class="classes" />
  <LazyAtomIconAppXFormerlyKnownAsTwitter v-if="icon === 'app-x-formerly-known-as-twitter'" :class="classes" />

  <!-- Regular icons -->
  <LazyAtomIconArrowDown v-if="icon === 'arrow-down'" :class="classes" />
  <LazyAtomIconArrowLeft v-if="icon === 'arrow-left'" :class="classes" />
  <LazyAtomIconArrowRight v-if="icon === 'arrow-right'" :class="classes" />
  <LazyAtomIconArrowUp v-if="icon === 'arrow-up'" :class="classes" />
  <LazyAtomIconBirthdayCake v-if="icon === 'birthday-cake'" :class="classes" />
  <LazyAtomIconCalendar v-if="icon === 'calendar'" :class="classes" />
  <LazyAtomIconCart v-if="icon === 'cart'" :class="classes" />
  <LazyAtomIconChain v-if="icon === 'chain'" :class="classes" />
  <LazyAtomIconCheck v-if="icon === 'check'" :class="classes" />
  <LazyAtomIconChevronDown v-if="icon === 'chevron-down'" :class="classes" />
  <LazyAtomIconChevronLeft v-if="icon === 'chevron-left'" :class="classes" />
  <LazyAtomIconChevronRight v-if="icon === 'chevron-right'" :class="classes" />
  <LazyAtomIconChevronUp v-if="icon === 'chevron-up'" :class="classes" />
  <LazyAtomIconCircledCheck v-if="icon === 'circled-check'" :class="classes" />
  <LazyAtomIconGear v-if="icon === 'gear'" :class="classes" />
  <LazyAtomIconHamburger v-if="icon === 'hamburger'" :class="classes" />
  <LazyAtomIconHeart v-if="icon === 'heart'" :class="classes" />
  <LazyAtomIconHeartFilled v-if="icon === 'heart-filled'" :class="classes" />
  <LazyAtomIconInstagram v-if="icon === 'instagram'" :class="classes" />
  <LazyAtomIconMail v-if="icon === 'mail'" :class="classes" />
  <LazyAtomIconMinus v-if="icon === 'minus'" :class="classes" />
  <LazyAtomIconPaw v-if="icon === 'paw'" :class="classes" />
  <LazyAtomIconPdfFile v-if="icon === 'pdf-file'" :class="classes" />
  <LazyAtomIconPerson v-if="icon === 'person'" :class="classes" />
  <LazyAtomIconPhone v-if="icon === 'phone'" :class="classes" />
  <LazyAtomIconPiggyBank v-if="icon === 'piggy-bank'" :class="classes" />
  <LazyAtomIconPlus v-if="icon === 'plus'" :class="classes" />
  <LazyAtomIconSearch v-if="icon === 'search'" :class="classes" />
  <LazyAtomIconWhatsApp v-if="icon === 'whats-app'" :class="classes" />
  <LazyAtomIconX v-if="icon === 'x'" :class="classes" />
</template>

<script setup lang="ts">
interface Props {
  icon: string
  class?: string | string[] | Record<string, boolean>
  classes?: string | string[] | Record<string, boolean>
}

const props = defineProps<Props>()

// Cant use `class` as a var name as it is a reserved keyword.
const classes = computed(() => props.class)
</script>
